import IconButton from "@/Components/IconButton/IconButton";
import { useSetModal } from "@/shared/atoms/useModal";
import useId from "@/shared/hooks/useId";
import { useTranslation } from "react-i18next";
import Tooltip from "@/Components/Tooltip/Tooltip";

const MapTop = ({ editable = true }: { editable: boolean }) => {
  const mapId = useId();
  const { t } = useTranslation("", { keyPrefix: "maps" });
  const setModal = useSetModal();
  return (
    <div
      className="flex items-center border-b-[1px_solid_var(--grey-blue-light)] p-4"
      style={{ fontWeight: "600" }}
    >
      <div className="mr-[auto]"> {t("tableOverview")}</div>
      {editable && (
        <div>
          <Tooltip content={t("addTable")}>
            <div>
              <IconButton
                onClick={() => setModal("table", { mapId })}
                size="small"
                variants="plus"
              />
            </div>
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default MapTop;
